$(document).ready(function () {
    var mobileNavHeight = $('#mobileNavBar').outerHeight() - 1;
    $('#navBar').css('top', mobileNavHeight + 'px' );
    $(".bridgman--sort--container li.cursor ").on("click", function (e) {
        let thisValue = $(this).attr('value');
        let selectBox = $("#SortBy.facet-filters__sort");
        let selectBoxOption = selectBox.children('option');

        $('#SortBy.facet-filters__sort option').each(function () {
            selectBoxOption.removeAttr('selected');
            if (thisValue === $(this).val()) {
                $(this).val(thisValue).attr("selected", "selected");
            }
        });
    });
    $('.price-filter-mobile .js--num, .price-filter-mobile .js--qty-adjuster').click(function (e){
        e.stopPropagation();
    });

    // ================================ Hidden Image Popup ================================

    $('.hidden-product-image-button').on('click',function(e){
        e.stopPropagation();
        $('.popupinfo').addClass('openpopup');
        $('.overlay').addClass('active');
        $('html').addClass('collectioniconpopup');
      });
      $('.close').on('click',function(){
        $('.popupinfo').removeClass('openpopup');
        $('.overlay').removeClass('active');
        $('html').removeClass('collectioniconpopup');
      });

      $('.option-okay').on('click',function(){
        $('.popupinfo').removeClass('openpopup');
        $('.overlay').removeClass('active');
        $('html').removeClass('collectioniconpopup');
        $('.bridgman-hidden-product-image-overlay').addClass('hidden');
      });

      // ================== hide popup on click outside ================

      $('.overlay').click(function() {
         $(".bridgman-hidden-product-image-overlay").addClass('hidden');
         $('.overlay').removeClass('active');
    });

      // ========================== Hidden Image Slider ===========================

      $('.model-slide-items').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide:true,
        arrows:true,
        asNavFor:'.slider-nav',
        adaptiveHeight: true
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.model-slide-items',
        focusOnSelect: true,
        adaptiveHeight: true,
        arrows:false,
        responsive:[
          {
            breakpoint: 1024,
            settings:{
              slidesToShow:3
            }
          },
          {
            breakpoint: 768,
            settings:{
              slidesToShow:2
            }
          },
          {
           breakpoint: 575,
              settings:{
              slidesToShow:1
            }
          }
        ]
      });

      // ==================== Refresh slick slider on popup open =================
      $('.hidden-product-image-button').on('click',function(){
        $('.model-slide-items').slick('refresh');
      });

    $(".brid-flex .variant li span").click(function(e)
    {
        e.preventDefault();
        e.stopPropagation();
        if(!$(this).data('media'))
            return;
        var parent = $(this).parents(".product-card");
        var img = parent.find(".prod-card-img");
        var media = $(this).data('media');
        img.attr('src',media);
    });
});


function showHiddenImagePopUp( )
{
    var popUpContainer = document.querySelector( ".bridgman-hidden-product-image-overlay" );

    popUpContainer.classList.remove( "hidden" );
}

function closeHiddenImagePopup( )
{
    var popUpContainer = document.querySelector( ".bridgman-hidden-product-image-overlay" );

    popUpContainer.classList.add( "hidden" );
}

function bridgamAddToCart(data) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (cart) {
            console.log(cart);
            var desktop_cart_count = $('.desktop-only .cart-count').text();
            desktop_cart_count = parseInt(desktop_cart_count);

            if ($('.desktop-only .cart-count, #mobileNavBar .cart-count').hasClass('hidden-count')) {
                $('.desktop-only .cart-count, #mobileNavBar .cart-count').removeClass("hidden-count");
            }
            $('.desktop-only .cart-count,#mobileNavBar .cart-count').text(desktop_cart_count + 1);
            //$("#ajax_cart__drawer").html(cart.sections['ajax-cart-drawer-section']);
            $('.ajax-brid-addtocart').find('input[type="submit"]').val("Add to your basket");
        },
        error: function (XMLHttpRequest, textStatus) {
        }
    };
    jQuery.ajax(params);
}

/****** Announcement bar Count Down ******/
if ( document.querySelectorAll( ".timer-block" ) ) 
{
    var times = document.querySelectorAll( ".timer-block" );
    times.forEach( ( timeEl ) =>
    {   
        var time = timeEl.getAttribute( "data-times" )
        var countDownDate = new Date(time).getTime();
        var x = setInterval(function () 
        {
            var now = new Date().getTime();
    
            var distance = countDownDate - now;
    
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
            timeEl.innerHTML = days + "d : " + hours + "h : "
                + minutes + "m : " + seconds + "s ";
    
            if (distance < 0) 
            {
                clearInterval(x);
                timeEl.innerHTML = "EXPIRED";
            }
        }, 1000);
    });
}
/****** End Announcement bar Count Down ******/


/****** Announcement bar Slider ******/
$(document).ready(function () 
{
    var announcementSliderEls = $( ".bridgman-announcement-bar-wrapper" );
  
    if (announcementSliderEls.length > 0) 
    {
        announcementSliderEls.each( function () 
        {
            var Autoplaysec   = $( this ).attr( "data-sliderautoplay" );
            var DesktopSlides = $( this ).attr( "data-desktop-slides" );
            var MobileSlides  = $( this ).attr( "data-mobile-slides" );
            if( !DesktopSlides )
            {
                var DesktopSlides = 1;
            }
            if( !MobileSlides )
            {
                var MobileSlides = 1;
            }
            $( this ).slick({
                infinite: true,
                slidesToShow: DesktopSlides,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: Autoplaysec,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                          slidesToShow: MobileSlides
                        }
                    }
                ]
            });
        });
    }
    announcementSliderEls.find( ".hidden" ).removeClass( "hidden" );
  });
  

/****** Announcement bar Slider End ******/

$(document).ready(function () {
    $(".where_you_hear").on("change", function () {
        $(this).parents('form').find(".bridgman-catalogue_other").addClass('hide');
        $(this).parents('form').find(".bridgman-catalogue_other").removeAttr("required");
        $(this).parents('form').find(".bridgman-catalogue_other").val('');
        if ($(this).val() == 'Other') {
            $(this).parents('form').find(".bridgman-catalogue_other").attr("required", "true");
            $(this).parents('form').find(".bridgman-catalogue_other").removeClass('hide');
        }
    });
});


// Single Product page customer Review Response
var tpWidget = document.querySelector('.product-page-tp-widget');
if( tpWidget )
{
    var templateId = tpWidget.getAttribute("data-template-id");
    var businessunitId = tpWidget.getAttribute("data-businessunit-id");
    var sku = tpWidget.getAttribute("data-sku");
    var url = 'https://widget.trustpilot.com/trustbox-data/'+ templateId +'?businessUnitId='+ businessunitId +'&locale=en-GB&sku='+ sku +'&reviewsPerPage=10&reviewLanguages=en';
    window.onload = function(){
        console.log(url);
        fetch(url)
            .then(
                response => response.json()
            ).then(
            response => {
                console.log(response);
                console.log(response.productReviews.reviews.length);
                if(response.productReviews.reviews.length > 0){
                    $('.template-product .customer-reviews-tab').removeClass('hide');
                }
            }
        );
    }
}

var detailsMetricToggle = document.querySelector('#bridgman-details-metric-toggle');
var values = document.querySelectorAll( ".bridgman-product-tech-det-val p" );
function ConvertTechnicalDetailsMetrics( detailsMetricToggle, values )
{
    values.forEach( function( value )
    {
        if( detailsMetricToggle.checked && value.innerText.slice(-2) == "cm" )
        {
            if( value.dataset.convertedMetric )
            {
                var metricValue = value.dataset.convertedMetric.split( "cm" )[ 0 ];
            }
            else
            {
                var metricValue = value.innerText.split( "cm" )[ 0 ];
            }
            metricValue = Number( metricValue );
            var imperialValue = metricValue / 2.54;
            value.innerText = imperialValue.toFixed( 0 ) + "in";
            value.dataset.convertedMetric = imperialValue;
        }
        else if( detailsMetricToggle.checked == false && value.innerText.slice(-2) == "in" )
        {
            if( value.dataset.convertedMetric )
            {
                var imperialValue = value.dataset.convertedMetric.split( "in" )[ 0 ];
            }
            else
            {
                var imperialValue = value.innerText.split( "in" )[ 0 ];
            }
            imperialValue = Number( imperialValue );
            var metricValue = imperialValue * 2.54;
            value.innerText = metricValue.toFixed( 0 ) + "cm";
            value.dataset.convertedMetric = metricValue;
        }
    } );
}
if( detailsMetricToggle )
{
    detailsMetricToggle.addEventListener( "change", function( e )
    {
        ConvertTechnicalDetailsMetrics( detailsMetricToggle, values );
    } );
}
ConvertTechnicalDetailsMetrics( detailsMetricToggle, values );
